var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fee-cost-table" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "get-action": _vm.queryApi,
          "hide-search": "",
          selection: _vm.selection,
          serial: _vm.serial,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _vm.isDetail
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onAdd },
                          },
                          [_vm._v(_vm._s(_vm.$t("addText")))]
                        )
                      : _vm._e(),
                    _vm.isDetail
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: tableOperationProp.notSelected,
                            },
                            on: { click: _vm.onDeleteSelected },
                          },
                          [_vm._v(_vm._s(_vm.$t("bulkDelText")))]
                        )
                      : _vm._e(),
                    _vm.isDetail
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled:
                                tableOperationProp.notSelected ||
                                !_vm.canBatchConfirmSelected,
                            },
                            on: { click: _vm.onBatchConfirm },
                          },
                          [_vm._v(_vm._s(_vm.$t("feeTab.batchConfirm")))]
                        )
                      : _vm._e(),
                    _vm.isDetail
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled:
                                tableOperationProp.notSelected ||
                                !_vm.canCancelConfirmSelected,
                            },
                            on: { click: _vm.onCancelConfirm },
                          },
                          [_vm._v(_vm._s(_vm.$t("feeTab.cancelConfirm")))]
                        )
                      : _vm._e(),
                    _c("BjFrontendExport", {
                      attrs: {
                        type: "primary",
                        disabled: tableOperationProp.notSelected,
                        "label-list": _vm.exportLabelList,
                        rows: _vm.selectedRows,
                        "file-name": _vm.fileName,
                      },
                      on: { "export-success": _vm.clearSelectedRows },
                    }),
                    _vm.isSummary
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onRefreshOrder },
                          },
                          [_vm._v(_vm._s(_vm.$t("feeTab.recalculateFee")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.visibleDropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop === "feeItem"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.feeItemList.bjGet(
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "chargeUnit"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.chargeUnitList.bjGet(
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "status"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.FEE_STATUS_LIST.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "verificationStatus"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.FEE_VERIFICATION_STATUS_LIST.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "source"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatSourceValue(
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]
                                      : col.digit !== undefined
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDecimalValue(
                                                scope.row[col.prop],
                                                col.digit
                                              )
                                            )
                                          ),
                                        ]
                                      : [_vm._v(_vm._s(scope.row[col.prop]))],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "text",
                                          disabled: !_vm.canEditRow(props.row),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.isDetail
        ? _c("FeeFormDialog", {
            ref: "feeFormDialog",
            attrs: {
              "fee-name-options": _vm.feeItemList,
              "charge-unit-options": _vm.chargeUnitList,
              "outer-order-no": _vm.outerOrderNo,
              type: _vm.type,
            },
            on: { saved: _vm.handleSaved },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }